import {createSlice} from '@reduxjs/toolkit'
import {decryptData} from "../../utils/AES256";

const defaultUserInfo = {
  name: '',
  picture: '',
  role: '',
  email: '',
  accessToken: ''
}

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    userInfo: defaultUserInfo
  },
  reducers: {
    setUserInfo: (state, action) => {
      const userInfo = action.payload.userInfo;
      sessionStorage.setItem("userInfo", userInfo);
      state.userInfo = decryptData(userInfo);
    },
    setUserInfoFromStorage: (state) => {
      const storedUserInfo = sessionStorage.getItem("userInfo");
      if (storedUserInfo !== null || storedUserInfo !== 'undefined') {
        try {
          state.userInfo = decryptData(storedUserInfo);
        } catch (error) {
          sessionStorage.removeItem("userInfo");
          state.userInfo = defaultUserInfo;
        }
      }
    },
  }
})

export const {
  setUserInfo, setUserInfoFromStorage
} = userSlice.actions

export default userSlice.reducer
